// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UpCircleOutlinedSvg from "@fishx/icons-svg/es/asn/UpCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var UpCircleOutlined = function UpCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UpCircleOutlinedSvg
  }));
};

UpCircleOutlined.displayName = 'UpCircleOutlined';
export default React.forwardRef(UpCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UpCircleOutlined.js
// module id = 4322
// module chunks = 0